import { createSelector } from 'reselect';
import { RootState } from "../state";

export const selectProfileState = (state: RootState) => state.profile

export const selectUserProfile = createSelector(
  selectProfileState,
  (state) => state?.userInfo
);

export const selectLoadingProfileStatus = createSelector(
  selectProfileState,
  (state) => state?.isLoading,
)

export const selectSavedProfileStatus = createSelector(
  selectProfileState,
  (state) => state?.saved,
)

export const selectSavingProfileStatus = createSelector(
  selectProfileState,
  (state) => state?.saving,
)
